const dias = ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado', 'Domingo']


const unidades = [
    {
        nome: 'Guaianases',
        shortname: 'guaianases',
        foto: `${process.env.PUBLIC_URL}/home/guaianases.png`,
        endereco: 'Rua Noventa e Cinco, 11 - Guaianases',
        telefone: '(11) 94954-9338',
        treinos: [
            {
                dia: dias[0],
                horario: '19h30 às 21h'
            },
            {
                dia: dias[2],
                horario: '19h30 às 21h'
            }
        ],
        maps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.1753298328435!2d-46.401046824460664!3d-23.562145678799332!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce65d273dc1f9d%3A0x5cac47ec48dac796!2sAcademia%20Karat%C3%AA%20Shotokan%20do%20ADK!5e0!3m2!1spt-BR!2sbr!4v1702934779277!5m2!1spt-BR!2sbr',
        fotos: [
            {
                title: 'Academia Guaianases',
                src: `https://imgur.com/WYM2stJ.jpg`,

                width: 1.5,
                height: 1
            },
            {
                title: 'Academia Guaianases',
                src: `https://imgur.com/p2BpKDW.jpg`,

                width: 2,
                height: 1
            },
            {
                title: 'Academia Guaianases',
                src: `https://imgur.com/PJIyTNA.jpg`,
                width: 1.5,
                height: 1
            },
            {
                title: 'Academia Guaianases',
                src: `https://imgur.com/f99maWY.jpg`,
                width: 2,
                height: 1
            },
            {
                title: 'Academia Guaianases',
                src: `https://imgur.com/eunvozT.jpg`,
                width: 2,
                height: 1
            }
        ]
    },
    {
        nome: 'Tiradentes Fiel',
        shortname: 'fiel',
        foto: `${process.env.PUBLIC_URL}/home/fiel.png`,
        endereco: 'Avenida dos Metalúrgicos, 2900 - Cidade Tiradentes',
        telefone: '(11) 95588-1602',
        treinos: [
            {
                dia: 'ATENÇÃO',
                horario: 'Academia em reforma.'
            }
        ],
        maps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3656.0889272956724!2d-46.40213212445954!3d-23.60114347877254!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce6fcb8473e2b1%3A0x3736e600eabc628e!2sADK%20KARAT%C3%8A%20SHOTOKAN%20II!5e0!3m2!1spt-BR!2sbr!4v1702935027792!5m2!1spt-BR!2sbr',
        fotos: [
            {
                title: 'Academia Fiel',
                src: `https://imgur.com/C9Ge8QG.jpg`,
                width: 2.5,
                height: 1
            },
            {
                title: 'Academia Fiel',
                src: `https://imgur.com/fpzvamI.jpg`,
                width: 1.5,
                height: 1
            },
            {
                title: 'Academia Fiel',
                src: `https://imgur.com/7e0wcIS.jpg`,
                width: 2,
                height: 1
            },
            {
                title: 'Academia Fiel',
                src: `https://imgur.com/JBy23SE.jpg`,
                width: 2,
                height: 1
            },
            {
                title: 'Academia Fiel',
                src: `https://imgur.com/5h0h0sU.jpg`,
                width: 2,
                height: 1
            }
        ]
    },
    {
        nome: 'Tiradentes ATG',
        shortname: 'atg',
        foto: `${process.env.PUBLIC_URL}/home/atg.png`,
        endereco: 'Avenida Leandro, 317 - Cidade Tiradentes',
        telefone: '(11) 95588-1602',
        treinos: [
            {
                dia: dias[1],
                horario: '19h às 20h20'
            },
            {
                dia: dias[3],
                horario: '19 às 20h'
            }
        ],
        maps: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14624.172741575145!2d-46.420282648324886!3d-23.602784109636595!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce6fa2d952096d%3A0xc743ce8120b3663c!2sADK%20KARAT%C3%8A%20SHOTOKAN%20III!5e0!3m2!1spt-BR!2sbr!4v1702935063138!5m2!1spt-BR!2sbr',
        fotos: [
            {
                title: 'Academia ATG',
                src: `https://imgur.com/TYGahBh.jpg`,
                width: 2,
                height: 1
            },
            {
                title: 'Academia ATG',
                src: `https://imgur.com/k0OUZuI.jpg`,
                width: 1,
                height: 2
            },
            {
                title: 'Academia ATG',
                src: `https://imgur.com/6EE2HwN.jpg`,
                width: 2,
                height: 1
            },
            {
                title: 'Academia ATG',
                src: `https://imgur.com/wNh5sww.jpg`,
                width: 2,
                height: 1
            },
            {
                title: 'Academia ATG',
                src: `https://imgur.com/vgXkEmA.jpg`,
                width: 2,
                height: 1
            }
        ]
    }
]

export default unidades;
